export const iconFontAwesomeDevicesHardwareKeyboard = (
	<i className="fa-solid fa-keyboard"></i>
);
